<section class="analogue-picker">
  <div class="analogue-picker__header">
    <div>
      <h2>Добавить ручной аналог</h2>
      <p>Поиск идёт по новому каталогу, без перехода в старый selector.</p>
    </div>

    <button
      mat-stroked-button
      type="button"
      color="primary"
      class="analogue-picker__create-toggle"
      (click)="toggleCreateForm()"
    >
      <mat-icon>{{ createFormOpened ? 'expand_less' : 'add_box' }}</mat-icon>
      {{ createFormOpened ? 'Скрыть создание' : 'Создать товар' }}
    </button>
  </div>

  <div class="analogue-picker__search-field">
    <div class="analogue-picker__search-label">Поиск товара</div>
    <mat-form-field appearance="outline" class="analogue-picker__search">
      <input
        matInput
        [formControl]="searchControl"
        placeholder="Введите артикул, бренд или наименование"
        (keydown.enter)="submitSearch($event)"
      />
      <button mat-icon-button matSuffix type="button" (click)="submitSearch()" aria-label="Искать">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <section class="analogue-picker__create-panel" *ngIf="createFormOpened">
    <div class="analogue-picker__create-panel-head">
      <h3>Создать новый товар</h3>
      <p>После создания новый товар сразу добавится в ручные аналоги.</p>
    </div>

    <app-product-create
      [initialArticle]="searchControl.value.trim()"
      (createdEvent)="handleCreatedProduct($event)"
    ></app-product-create>
  </section>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="analogue-picker__state" *ngIf="errorMessage">{{ errorMessage }}</div>

  <div class="analogue-picker__results" *ngIf="results.length">
    <div class="analogue-picker__results-meta">Найдено {{ results.length }} товаров</div>

    <div class="analogue-picker__table-shell">
      <table class="analogue-picker__table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Картинка</th>
            <th>Наименование</th>
            <th>Производитель</th>
            <th>Артикул</th>
            <th class="analogue-picker__action-col">Действие</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of results">
            <td class="analogue-picker__id-cell">{{ item.id }}</td>

            <td>
              <a
                *ngIf="getProductImageUrl(item) as productImageUrl; else noProductImage"
                class="analogue-picker__product-image"
                [href]="productImageUrl"
                target="_blank"
                rel="noopener noreferrer"
                (mouseenter)="showImagePreview($event, productImageUrl, item.name)"
                (mousemove)="moveImagePreview($event)"
                (mouseleave)="hideImagePreview()"
              >
                <img [src]="productImageUrl" [alt]="item.name" />
              </a>

              <ng-template #noProductImage>
                <div class="analogue-picker__product-image analogue-picker__product-image--empty">
                  <mat-icon>image_not_supported</mat-icon>
                </div>
              </ng-template>
            </td>

            <td class="analogue-picker__name-cell">
              <div class="analogue-picker__name">{{ item.name }}</div>
            </td>

            <td>
              <div class="analogue-picker__brand-cell">
                <div
                  *ngIf="getBrandLogoUrl(item) as brandLogoUrl; else noBrandLogo"
                  class="analogue-picker__brand-logo"
                >
                  <img [src]="brandLogoUrl" [alt]="item.brandName" />
                </div>

                <ng-template #noBrandLogo>
                  <div class="analogue-picker__brand-logo analogue-picker__brand-logo--empty">
                    {{ item.brandName.slice(0, 1) }}
                  </div>
                </ng-template>

                <div class="analogue-picker__brand-meta">
                  <div class="analogue-picker__brand-name">{{ item.brandName }}</div>

                  <div class="analogue-picker__brand-rating" *ngIf="item.brandRating; else noBrandRating">
                    <span class="analogue-picker__brand-stars">
                      <mat-icon *ngFor="let _ of getBrandRatingRange(item)">star</mat-icon>
                    </span>
                    <span class="analogue-picker__brand-rating-value">{{ item.brandRating }}/5</span>
                  </div>

                  <ng-template #noBrandRating>
                    <span class="analogue-picker__brand-rating analogue-picker__brand-rating--empty">
                      Без рейтинга
                    </span>
                  </ng-template>
                </div>
              </div>
            </td>

            <td class="analogue-picker__article-cell">{{ item.article }}</td>

            <td class="analogue-picker__action-cell">
              <button
                mat-flat-button
                color="primary"
                type="button"
                [disabled]="addingProductId === item.id"
                (click)="add(item)"
              >
                {{ addingProductId === item.id ? 'Добавление...' : 'Добавить' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div
    class="analogue-picker__image-hover-preview"
    *ngIf="hoveredImageUrl"
    [style.left.px]="hoveredImagePreviewLeft"
    [style.top.px]="hoveredImagePreviewTop"
  >
    <img [src]="hoveredImageUrl" [alt]="hoveredImageTitle || 'Предпросмотр изображения товара'" />
  </div>
</section>
